import { useCurrentWorkspace } from '@cube3/state/src/redux/components/Administration/withCurrentWorkspace';
import { useResourceList__ALPHA } from '@cube3/state/src/redux/components/Hooks/useResourceList';
import { useMemo } from 'react';

const categoryParams = {
  filter: { categories_for: 'project' }
};

/** A hook that
 * - retrieve the metadata categories for projects,
 * - check if should open/pre-fill metadata fields before creating project.
 */
export const useProjectMetadataFields = ({ filterValues = {} }) => {
  const [workspaceId] = useCurrentWorkspace();

  const cats = useResourceList__ALPHA({
    resourceType: 'workspace',
    resourceId: workspaceId,
    edgeLabel: 'metadata-categories',
    edgeType: 'metadata-category',
    strategy: 'fetch-on-mount',
    params: categoryParams
  }).resources;

  /** Open `EditNewProjectMetadata` if
   * - there are required metadata fields,
   * - or there are selected metadata filters (get from url params)
   */
  const prefillMetadataCheck = useMemo(() => {
    const hasRequiredFields =
      cats &&
      cats.findIndex(
        (field) =>
          field?.metadata_fields?.filter((f) => !!f.required).length > 0
      ) > -1;
    const hasPrefilledValue =
      filterValues &&
      Object.keys(filterValues).filter((key) => !!filterValues[key]).length > 0;
    return {
      hasRequiredFields,
      hasPrefilledValue,
      should: hasRequiredFields || hasPrefilledValue
    };
  }, [filterValues, cats]);

  return {
    retrievedForms: cats,
    prefillMetadataCheck
  };
};
